import React from 'react';
import {
  Box,
  Button,
  Tabs,
  Tab,
  CircularProgress,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { tokens, withAlpha } from '../../Common/designTokens';
import { EDI_FILE_PROCESS_FILTER_PORTAL_ID } from '../../Constants/AppConstants';

const SessionUserHeader = ({
  activeTab,
  setActiveTab,
  handleAddEdit,
  loading,
  canWrite = false,
}) => {
  const writeAccessDeniedMessage = 'Only SUPER_ADMIN can modify session and user configuration.';

  const handleAddClick = () => {
    if (!canWrite) return;
    if (handleAddEdit) {
      handleAddEdit();
    }
  };

  return (
    <Box sx={{ color: tokens.colors.fontColour, padding: '16px', paddingY: '14px', paddingBottom: '0px' }}>
      {/* Top section with title and buttons */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: { xs: 'flex-end' },
          justifyContent: 'space-between',
          gap: { xs: 2, sm: 0 },
          borderBottom: `1px solid ${withAlpha(tokens.colors.gray, 0.2)}`,
          minHeight: '48px',
          height: 'auto',
        }}
      >
        <Tabs
          value={activeTab}
          onChange={(e, newValue) => setActiveTab(newValue)}
          textColor="inherit"
          sx={{
            minHeight: '36px',
            '& .MuiTab-root': {
              color: tokens.colors.fontColour,
              textTransform: 'none',
              minHeight: '36px',
            },
            '& .Mui-selected': {
              borderRadius: 0,
              backgroundColor: 'transparent !important',
              borderBottom: `1px solid ${tokens.palette.primary} !important`,
            },
          }}
        >
          {loading && activeTab === 0 ? (
            <Tab
              sx={{ fontSize: '16px', color: tokens.colors.fontColour }}
              label={
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  Session Config
                  <CircularProgress size={16} sx={{ marginLeft: 1 }} />
                </Box>
              }
            />
          ) : (
            <Tab sx={{ fontSize: '16px', color: tokens.colors.fontColour }} label="Session Config" />
          )}

          {loading && activeTab === 1 ? (
            <Tab
              sx={{ fontSize: '16px', color: tokens.colors.fontColour }}
              label={
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  User Config
                  <CircularProgress size={16} sx={{ marginLeft: 1 }} />
                </Box>
              }
            />
          ) : (
            <Tab sx={{ fontSize: '16px', color: tokens.colors.fontColour }} label="User Config" />
          )}

          {loading && activeTab === 2 ? (
            <Tab
              sx={{ fontSize: '16px', color: tokens.colors.fontColour }}
              label={
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  EDI File Processing
                  <CircularProgress size={16} sx={{ marginLeft: 1 }} />
                </Box>
              }
            />
          ) : (
            <Tab sx={{ fontSize: '16px', color: tokens.colors.fontColour }} label="EDI File Processing" />
          )}
        </Tabs>

        {/* Action buttons */}
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', pb: '4px' }}>
          {activeTab !== 2 && (
            <Button
            onClick={handleAddClick}
            color="inherit"
            variant="contained"
            startIcon={<AddIcon />}
            disabled={!canWrite}
            title={!canWrite ? writeAccessDeniedMessage : undefined}
            sx={{
              display: "flex",
              height: 42,
              textTransform: "none",
              boxShadow: "none",
              borderRadius: "8px",
              backgroundColor: tokens.colors.defaultGridRowColor,
              color: tokens.colors.fontColour,
              border: `1px solid ${tokens.colors.bodyBorderColor50}`,
              width: { xs: "100%", sm: "auto" },
              "&:hover": { backgroundColor: tokens.colors.defaultGridHoverColor },
              "&.Mui-disabled": {
                backgroundColor: tokens.colors.defaultGridRowColor,
                color: tokens.colors.disabledFontColour,
                border: `1px solid ${tokens.colors.bodyBorderColor50}`,
                opacity: 0.7,
              },
              fontWeight: 700,
            }}
            >
              {activeTab === 0 ? 'Add Session Config' : 'Add User Config'}
            </Button>
          )}
          {activeTab === 2 && (
            <Box
              id={EDI_FILE_PROCESS_FILTER_PORTAL_ID}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                minHeight: 42,
              }}
            />
          )}
        </Box>
      </Box>

      {/* Sub-tabs section - only for staging blotter (if needed in future) */}
      {/* Currently not needed as we only have two main tabs */}
    </Box>
  );
};

export default SessionUserHeader;
